import { LucideIcon } from 'lucide-react';

interface ComingSoonProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  className?: string;
}

export function ComingSoon({
  icon: Icon,
  title,
  description,
  className = '',
}: ComingSoonProps) {
  return (
    // `key` forces a remount when this component is reused across tab
    // switches at the same tree position (e.g. Glossary ↔ Extras in empty
    // mode). Without it React keeps the same DOM node and `animate-fade-in`
    // never replays.
    <div
      key={title}
      className={`flex h-full animate-fade-in flex-col items-center justify-center px-4 py-16 ${className}`}
    >
      {/* Icon - disc size matches the lesson-page Panel components so
          empty + loading + generate states all share proportions. */}
      <div className='mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-brand-50 dark:bg-muted'>
        <Icon className='h-7 w-7 text-brand-500/80 dark:text-primary' />
      </div>

      {/* Coming Soon Badge */}
      <div className='mb-4 inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-3 py-1 dark:border-primary dark:bg-tint-brand-strong'>
        <span className='text-xs font-medium text-blue-700 dark:text-tint-brand-strong-foreground'>
          Coming Soon
        </span>
      </div>

      {/* Title */}
      <h3 className='mb-2 text-lg font-medium text-foreground'>{title}</h3>

      {/* Description */}
      {description && (
        <p className='max-w-sm text-center text-sm text-muted-foreground'>
          {description}
        </p>
      )}
    </div>
  );
}
